import {createSvgIcon} from '../create-svg-icon';

export const AirplayIcon = createSvgIcon(
  [<path d="M6 22h12l-6-6z" key="0" />,<path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" key="1" />,]
, 'AirplayOutlined');
